import { Spin } from "antd";
import { Navigate } from "react-router-dom";

import { useAuth, AuthenticationStatus } from "./useAuth";

/**
 * Wrap the routes with a public route component to check if the user is not authenticated
 * and to redirect to the dashboard page if they are.
 */
const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const auth = useAuth();

  switch (auth.authenticationStatus) {
    case AuthenticationStatus.LOADING:
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Spin />
        </div>
      );
    case AuthenticationStatus.LOGGED_IN:
      return <Navigate to="/" />;
    case AuthenticationStatus.LOGGED_OUT:
      return children;
  }
};

export default PublicRoute;
